import { defineGlobalStyles } from '@chakra-ui/react/styled-system';

import { rem } from './themeUtils';

const globalCss = defineGlobalStyles({
  '*': {
    '--global-font-mono': 'fonts.mono',
    '--global-font-body': 'fonts.body',
    '--focus-ring-width': rem(3),
    '--focus-ring-offset': '0',
    '--focus-ring-style': 'solid',
    '--focus-ring-color': 'colors.border/focus',
  },
  body: {
    background: 'background/primary',
    color: 'text/body',
    textStyle: 'body/lg/regular',
  },
  "a, summary, button, input, textarea, select, [tabindex]:not([tabindex='-1'])": {
    outline: 'none',
    focusVisibleRing: 'outside',
  },
  // Anything you can activate shows it, and nothing disabled does -- `:disabled` only covers native
  // controls, so the ARIA and Zag disabled markers are excluded too. Recipes that style a disabled
  // state (`not-allowed`) still win: they sit in a later cascade layer than these global styles.
  "button, [role='button'], summary": {
    '&:not(:disabled, [aria-disabled=true], [data-disabled])': {
      cursor: 'pointer',
    },
  },
});

export default globalCss;
